/**
 * Color tokens
 */
const staticColors = {
  gray_001_00000040: "#00000040",
  green_001_003814: "#003814",
  green_002_022c22: "#022c22",
  green_003_047857: "#047857",
  green_004_059669: "#059669",
  green_005_065f46: "#065f46",
  green_006_0a9f2f: "#0a9f2f",
  green_007_0b6f18: "#0b6f18",
  green_008_0e8f1e: "#0e8f1e",
  blue_001_0f1420: "#0f1420",
  blue_002_0f172a: "#0f172a",
  green_009_0f8a1f: "#0f8a1f",
  green_010_119b2a: "#119b2a",
  blue_003_121926: "#121926",
  green_011_12922e: "#12922e",
  green_012_12992a: "#12992a",
  green_013_134e2f: "#134e2f",
  green_014_15803d: "#15803d",
  green_015_159535: "#159535",
  green_016_159a2f: "#159a2f",
  blue_004_161c2d: "#161c2d",
  green_017_166534: "#166534",
  green_018_16a34a: "#16a34a",
  blue_005_171a1f14: "#171a1f14",
  blue_006_171a1f17: "#171a1f17",
  blue_007_171c27: "#171c27",
  green_019_18461a: "#18461a",
  blue_008_1a2238: "#1a2238",
  blue_009_1b212d: "#1b212d",
  blue_010_1c2230: "#1c2230",
  blue_011_1d2433: "#1d2433",
  blue_012_1d4ed8: "#1d4ed8",
  blue_013_1e3a5f: "#1e3a5f",
  blue_014_1f2430: "#1f2430",
  blue_015_1f2937: "#1f2937",
  blue_016_1f3347: "#1f3347",
  green_020_1f9f3d: "#1f9f3d",
  blue_017_223046: "#223046",
  green_021_22c55e: "#22c55e",
  blue_018_232938: "#232938",
  green_022_23903a: "#23903a",
  blue_019_24304a: "#24304a",
  blue_020_25234b: "#25234b",
  blue_021_2563eb: "#2563eb",
  blue_022_262633: "#262633",
  blue_023_262b38: "#262b38",
  blue_024_262d3a: "#262d3a",
  blue_025_2a3142: "#2a3142",
  green_023_2a9e4b: "#2a9e4b",
  blue_026_2b3242: "#2b3242",
  green_024_2c9e4b: "#2c9e4b",
  green_025_2ca744: "#2ca744",
  blue_027_2d3342: "#2d3342",
  blue_028_2d3547: "#2d3547",
  blue_029_2e3442: "#2e3442",
  green_026_2e7d32: "#2e7d32",
  green_027_2e9b3f: "#2e9b3f",
  blue_030_2f2e3c: "#2f2e3c",
  blue_031_2f3443: "#2f3443",
  blue_032_2f80ed: "#2f80ed",
  blue_033_303643: "#303643",
  green_028_32a94b: "#32a94b",
  gray_002_333: "#333",
  green_029_34c184: "#34c184",
  purple_001_3b3744: "#3b3744",
  blue_034_3b82f6: "#3b82f6",
  green_030_3bb04d: "#3bb04d",
  blue_035_3c4b5c: "#3c4b5c",
  purple_002_3e3a46: "#3e3a46",
  green_031_3fab4f: "#3fab4f",
  green_032_41b35a: "#41b35a",
  blue_036_424856: "#424856",
  blue_037_4285f4: "#4285f4",
  gray_003_444: "#444",
  green_033_45ad51: "#45ad51",
  green_034_4caf50: "#4caf50",
  blue_038_4d5565: "#4d5565",
  blue_039_4e596d: "#4e596d",
  blue_040_525b6d: "#525b6d",
  green_035_52b463: "#52b463",
  blue_041_535862: "#535862",
  blue_042_576174: "#576174",
  red_001_585555: "#585555",
  blue_043_596174: "#596174",
  blue_044_5a6272: "#5a6272",
  blue_045_5a6373: "#5a6373",
  blue_046_5a6475: "#5a6475",
  blue_047_5b6473: "#5b6473",
  blue_048_5f6570: "#5f6570",
  blue_049_5f6674: "#5f6674",
  blue_050_616a7b: "#616a7b",
  blue_051_626d7f: "#626d7f",
  blue_052_64748b: "#64748b",
  green_036_678974: "#678974",
  blue_053_687083: "#687083",
  blue_054_697486: "#697486",
  blue_055_6a7382: "#6a7382",
  blue_056_6b7383: "#6b7383",
  gray_004_6c6c6c: "#6c6c6c",
  blue_057_6d7481: "#6d7481",
  blue_058_72777d: "#72777d",
  blue_059_7a8699: "#7a8699",
  yellow_001_8a6a12: "#8a6a12",
  orange_001_8b4513: "#8b4513",
  blue_060_8b8f95: "#8b8f95",
  blue_061_8fa0bd: "#8fa0bd",
  cyan_001_95c4bd: "#95c4bd",
  red_002_991b1b: "#991b1b",
  green_037_9fcca6: "#9fcca6",
  red_003_a01d1d: "#a01d1d",
  orange_002_a0522d: "#a0522d",
  green_038_a8b5a0: "#a8b5a0",
  green_039_afe5b6: "#afe5b6",
  red_004_b42318: "#b42318",
  cyan_002_b8d9d4: "#b8d9d4",
  red_005_b91c1c: "#b91c1c",
  green_040_bbf7d0: "#bbf7d0",
  blue_062_bce3ff: "#bce3ff",
  green_041_bee8c6: "#bee8c6",
  gray_005_bfbfbf: "#bfbfbf",
  blue_063_bfdbfe: "#bfdbfe",
  green_042_c4f4e4: "#c4f4e4",
  green_043_c7ebcf: "#c7ebcf",
  blue_064_c8ccd5: "#c8ccd5",
  blue_065_cbd5e1: "#cbd5e1",
  blue_066_ccd4df: "#ccd4df",
  blue_067_cfd7e5: "#cfd7e5",
  green_044_d1fae5: "#d1fae5",
  blue_068_d3d7df: "#d3d7df",
  blue_069_d5d9e0: "#d5d9e0",
  blue_070_d6dbe5: "#d6dbe5",
  green_045_d6e8dc: "#d6e8dc",
  blue_071_d7ddea: "#d7ddea",
  blue_072_d7ddeb: "#d7ddeb",
  green_046_d7f1db: "#d7f1db",
  green_047_d7f3db: "#d7f3db",
  blue_073_d8d4fe: "#d8d4fe",
  blue_074_d8e0ec: "#d8e0ec",
  green_048_d8e2d9: "#d8e2d9",
  gray_006_d9d9d9: "#d9d9d9",
  blue_075_d9dfeb: "#d9dfeb",
  green_049_d9f1df: "#d9f1df",
  blue_076_dbeafe: "#dbeafe",
  green_050_dbf2df: "#dbf2df",
  blue_077_dce0e7: "#dce0e7",
  blue_078_dce2ed: "#dce2ed",
  blue_079_dce5f1: "#dce5f1",
  green_051_dcfce7: "#dcfce7",
  blue_080_dfe5f0: "#dfe5f0",
  green_052_dff2e1: "#dff2e1",
  blue_081_e2e5eb: "#e2e5eb",
  blue_082_e2e6ed: "#e2e6ed",
  blue_083_e2e8f0: "#e2e8f0",
  blue_084_e3e5eb: "#e3e5eb",
  blue_085_e5e7eb: "#e5e7eb",
  blue_086_e5e9f2: "#e5e9f2",
  blue_087_e5f2ff: "#e5f2ff",
  blue_088_e6e7eb: "#e6e7eb",
  blue_089_e6e8ef: "#e6e8ef",
  blue_090_e7e9ef: "#e7e9ef",
  green_053_e7ebe9: "#e7ebe9",
  green_054_e7efea: "#e7efea",
  gray_007_e8e8e8: "#e8e8e8",
  blue_091_e8ebf1: "#e8ebf1",
  blue_092_e8edf7: "#e8edf7",
  red_006_ea4546cc: "#ea4546cc",
  green_055_eaf2ec: "#eaf2ec",
  green_056_eaf3ea: "#eaf3ea",
  green_057_eaf3ec: "#eaf3ec",
  blue_093_ebf7ff: "#ebf7ff",
  blue_094_ececef: "#ececef",
  blue_095_eceef3: "#eceef3",
  blue_096_eceff3: "#eceff3",
  blue_097_ecf0f7: "#ecf0f7",
  green_058_edf2ee: "#edf2ee",
  green_059_edf3ed: "#edf3ed",
  blue_098_eef2f7: "#eef2f7",
  green_060_eef4f0: "#eef4f0",
  gray_008_efefef: "#efefef",
  blue_099_eff6ff: "#eff6ff",
  red_007_f04438: "#f04438",
  red_008_f0d2d2: "#f0d2d2",
  gray_009_f0f0f0: "#f0f0f0",
  blue_100_f0f9ff: "#f0f9ff",
  green_061_f0fdf4: "#f0fdf4",
  red_009_f1c2c2: "#f1c2c2",
  blue_101_f1f5f9: "#f1f5f9",
  green_062_f1faf3: "#f1faf3",
  green_063_f2f7f2: "#f2f7f2",
  green_064_f3f6f3: "#f3f6f3",
  blue_102_f3f7fb: "#f3f7fb",
  red_010_f4c7c7: "#f4c7c7",
  red_011_f5c2c7: "#f5c2c7",
  yellow_002_f5edba: "#f5edba",
  blue_103_f5f5f7: "#f5f5f7",
  green_065_f5f7f6: "#f5f7f6",
  blue_104_f5f7fb: "#f5f7fb",
  blue_105_f6f8fb: "#f6f8fb",
  blue_106_f7f8f9: "#f7f8f9",
  blue_107_f7f8fa: "#f7f8fa",
  blue_108_f7f9fc: "#f7f9fc",
  green_066_f7fffa: "#f7fffa",
  blue_109_f8f9fc: "#f8f9fc",
  green_067_f8faf9: "#f8faf9",
  blue_110_f8fafc: "#f8fafc",
  gray_010_f9f9f9: "#f9f9f9",
  blue_111_f9fafc: "#f9fafc",
  yellow_003_facc15: "#facc15",
  blue_112_fafbfd: "#fafbfd",
  red_012_fb4337: "#fb4337",
  red_013_fecaca: "#fecaca",
  orange_003_fed7aa: "#fed7aa",
  orange_004_fee1c5: "#fee1c5",
  red_014_fee2e2: "#fee2e2",
  red_015_fef2f2: "#fef2f2",
  orange_005_ff9800: "#ff9800",
  red_016_ffb6c1: "#ffb6c1",
  red_017_fff1f1: "#fff1f1",
  red_018_fff4f4: "#fff4f4",
  red_019_fff5f5: "#fff5f5",
  orange_006_fff7ed: "#fff7ed",
} as const;

export const colors = {
  // Official Andy Brand Guidelines Tokens
  brand: {
    andyForest: "#2D6A4F", // 01 Primary
    actionGreen: "#1F7C43", // 02 Signal
    mintVeil: "#E8F2EC", // 03 Tint
    warmPaper: "#FAF8F4", // 04 Background
    deepForest: "#2F4134", // 05 Contrast
    softSand: "#F0EDE6", // 06 Neutral
  },
  primary: {
    main: "#2D6A4F", // Andy Forest
    dark: "#1F7C43", // Action Green
    50: "#FAF8F4",
    100: "#E8F2EC",
    500: "#2D6A4F",
    600: "#1F7C43",
    700: "#2F4134",
  },
  secondary: {
    50: "#FAF8F4",
    100: "#F0EDE6",
    500: "#71717a",
    600: "#52525b",
    700: "#2F4134",
  },
  light: {
    white: "#ffffff",
    50: "#FAF8F4",
    100: "#F0EDE6",
    200: "#e4e4e7",
    300: "#d4d4d8",
    400: "#a1a1aa",
    500: "#71717a",
    600: "#52525b",
    700: "#3f3f46",
    800: "#27272a",
    900: "#2F4134",
  },
  white: "#ffffff",
  success: "#1F7C43",
  error: "#ef4444",
  warning: "#f59e0b",
  info: "#2D6A4F",

  static: staticColors,

  about: {
    section: {
      background: "#FAF8F4",
    },
    card: {
      background: "#ffffff",
      border: "#F0EDE6",
      text: "#2F4134",
    },
  },
  pricing: {
    section: {
      background: "#E8F2EC",
    },
    savingsCard: {
      background: "#E8F2EC",
    },
    pricingCard: {
      background: "#FAF8F4",
    },
  },
} as const;
